/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-09 10:48:09
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-09-18 10:14:10
 * @FilePath: /dbrank_b/src/routes/visualChart/components/Chart/index.js
 * @Description: echarts5图表功能
 */
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import s from './index.css';
import { init } from 'echarts5'
import Button from '../Button';
import { trim } from 'lodash';

class Chart extends Component {
  static propTypes = {
    options: PropTypes.object.isRequired,
    isShow: PropTypes.bool,
  }
  constructor(props) {
    super(props);

    this.state = {
      isShow: props.isShow || false,
    };

    if (global.ResizeObserver) {
      // eslint-disable-next-line no-undef
      this.resizeObserver = new ResizeObserver(() => {
        this.resize();
      });
    }
  }
  ref = null;
  chart = null;

  componentDidMount() {
    const { options } = this.props;
    const dom = this.ref;
    this.chart = init(dom);
    this.setOption(options);
    if (this.resizeObserver) {
      this.resizeObserver.observe(dom);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { options } = this.props;
    if(nextProps.options !== options) {
      this.setOption(nextProps.options);
    }
  }

  componentWillUnmount() {
    this.chart && this.chart.dispose();
  }

  getOption = (options) => {
    const { isShow } = this.state;
    const { title, series } = options || {};
    let _series = series;

    if (Array.isArray(series)) {
      _series = _series.map(item => ({
        ...item,
        label: { ...item.label, show: isShow },
      }))
    } else {
      _series = {
        ..._series,
        label: { ..._series.label, show: isShow },
      }
    }


    if (Array.isArray(title)) {
      return {
        ...options,
        title: title.map(item => ({
          ...item,
          text: item.text ? ' ' : item.text,
        })),
        series: _series,
      }
    }
    if(title) {
      return {
        ...options,
        title: {
          ...options.title,
          text: title && title.text ? ' ' : title.text,
        },
        series: _series,
      }
    }

    return {
      ...options,
      series: _series,
    }
  }

  setOption = (options) => {
    try {
      if(this.chart) {
        this.chart.clear();
        this.chart.setOption(this.getOption(options));
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    }
  }

  resize = () => {
    try {
      this.chart.resize({
        width: 'auto',
        height: 'auto',
      })
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('resize', err);
    }
  }

  toggleLabel = () => {
    const show = !this.state.isShow
    this.setState({
      isShow: show,
    }, () => {
      const { options } = this.props;
      this.setOption(options);
    })
  }
  
  getTitle = () => {
    const { options } = this.props;
    
    const itemRender = (item = {}, index) => {
      if (typeof item.text === 'string' && item.text) {
        const reg = /{[^}]+}/g;
        let renderList = [item.text];
        let data = item.text.match(reg);

        if (data && item.textStyle && item.textStyle.rich) {
          data = data.map(text => text.slice(1, -1)).map(text => text.split('|'));
          renderList = item.text.split(reg);
          
          data.forEach((ele, index) => {
            const startIndex = index * 2 + 1
            renderList.splice(startIndex, 0, (
              <span style={item.textStyle.rich[trim(ele[0])]}>{ele[1]}</span>
            ));
          });
        }
  
        return (
          <div
            key={`${index}_key`}
            contentEditable
            style={{
              ...item.textStyle || {},
              top: item.top ? item.top : (item.bottom ? 'auto' : 0),
              left: item.left || 'auto',
              bottom: item.bottom || 'auto',
              textAlign: item.textAlign || 'left',
            }}
            className={s.title}>
            {renderList}
          </div>
        )
      }

      return null;
    };

    const { title } = options || {};
    if (Array.isArray(title)) {
      return title.map(itemRender)
    }

    return itemRender(title, 'index')
  }

  render() {
    const { isShow } = this.state;
    return (
      <div className={s.root}>
        <div ref={ref => this.ref = ref} className={s.chartWrapper} />
        <div className={s.btnGroup}>
          <Button type="primary" onClick={this.toggleLabel}>{!isShow ? '显示': '隐藏'}label</Button>
        </div>
        {this.getTitle()}
      </div>
    )
  }
}

export default withStyles(s)(Chart);


// WEBPACK FOOTER //
// src/routes/visualChart/components/Chart/index.js